import { useState, forwardRef, useImperativeHandle } from 'react';
import { Alert, Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateAccount } from '../../controllers/user';
import Loading from '../loading/Loading';

const PerfilCuentaForm = forwardRef((props, ref) => {
  const [email, setEmail] = useState(props.email);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  useImperativeHandle(ref, () => ({
    getCuenta() {
      return generateCuenta();
    }
  }));

  function generateCuenta() {
    return {
      email: email,
      password: password,
    };
  }

  async function submitUpdate() {
    setLoading(true);
    try {
      await updateAccount(token, props.userId, email, password);
      setAlert(<Alert variant='success' onClose={() => setAlert()} dismissible>La información se actualizó con éxito.</Alert>);
    }
    catch (e) {
      setAlert(<Alert variant='danger' onClose={() => setAlert()} dismissible>Ocurrió un error. Por favor intenta de nuevo más tarde.</Alert>);
    }
    setLoading(false);
  }

  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-cuenta' type='submit' variant='primary' onClick={submitUpdate}>Actualizar cuenta</Button>
      </Form.Group>;
    }
  }

  if (loading) {
    return <Row>
      <Loading text="Actualizando cuenta..." />
    </Row>
  }

  return <Row>
    <Col>
      {alert}
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" disabled={!!props.updateProfile} placeholder="Enter email" value={email} onChange={e => setEmail(e.target.value)} required />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
      </Form.Group>

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default PerfilCuentaForm;